import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  chatAlertDisabled: false,
  nonChatAlertDisabled: false,
};

const sounds = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'TOGGLE_CHAT_ALERT_DISABLED':
      return dotProp.set(state, 'chatAlertDisabled', action.value);
    case 'TOGGLE_NON_CHAT_ALERT_DISABLED':
      return dotProp.set(state, 'nonChatAlertDisabled', action.value);
    default:
      return state;
  }
};

export default sounds;
